module.exports = __webpack_public_path__ + "ce7681aa400ed039d90f9f674b9a73c5.MP3";